/**
 * Slider (image + text) inside dynamic_module_12_12.
 * Syncs media + text Swipers; slide headlines render as title pagination
 * below the module headline.
 */
(function () {
	'use strict';

	function escapeHtml(str) {
		return String(str)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;')
			.replace(/'/g, '&#39;');
	}

	function initSliderImgText() {
		if (typeof Swiper === 'undefined') {
			return;
		}

		document.querySelectorAll('.slider-img-text').forEach(function (root) {
			var mediaEl = root.querySelector('.slider-img-text__media-swiper');
			var textEl = root.querySelector('.slider-img-text__text-swiper');

			if (!mediaEl || !textEl) {
				return;
			}

			var textSlides = textEl.querySelectorAll('.swiper-slide');
			var slideCount = textSlides.length;
			if (!slideCount) {
				return;
			}

			var titles = Array.prototype.map.call(textSlides, function (slide, index) {
				var title = (slide.getAttribute('data-pagination-title') || '').trim();
				return title || String(index + 1);
			});

			var paginationEl = root.querySelector('.slider-img-text__pagination .swiper-pagination');

			var shared = {
				direction: 'horizontal',
				loop: false,
				slidesPerView: 1,
				spaceBetween: 0,
				slidesPerGroup: 1,
				speed: 700,
				centeredSlides: false,
				watchOverflow: true,
			};

			var mediaSwiper = new Swiper(mediaEl, shared);

			var textConfig = Object.assign({}, shared);
			if (paginationEl) {
				textConfig.pagination = {
					el: paginationEl,
					clickable: true,
					renderBullet: function (index, className) {
						var label = escapeHtml(titles[index] || String(index + 1));
						return (
							'<button type="button" class="' +
							className +
							' slider-img-text__pagination-title box-title" role="tab" aria-label="' +
							label +
							'">' +
							label +
							'</button>'
						);
					},
				};
			}

			var textSwiper = new Swiper(textEl, textConfig);

			mediaSwiper.controller.control = textSwiper;
			textSwiper.controller.control = mediaSwiper;
		});
	}

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', initSliderImgText);
	} else {
		initSliderImgText();
	}
})();
